import React, { Component } from 'react';

class Page404 extends Component {
  constructor(props) {
    super(props);

    this.goHome = this.goHome.bind(this)
  }

  goHome() {
    this.props.history.push('/')
  }

  render() {
    return (
    <div className="container">
      <div className="h-60vh flex-row align-items-center" >
        <div className="container full-width">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="clearfix text-center">
                <h1 className="display-3 mr-4">404</h1>
                <h4 className="pt-3">Oops! You're lost.</h4>
                <p className="text-muted">The page you are looking for was not found.</p>
                <button className="btn btn-blue-g btn-round" onClick={this.goHome}>Go Home</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
  }
}

export default Page404;




// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/page/page404.js